import { httpClient } from '@/Common/api/http_client';

// =========================================
// Merchant Specific APIs starts
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllPaymentMethods() {
  return httpClient.get('/merchant/payment-methods');
}

/**
 *
 * @param paymentMethodId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getPaymentMethod(paymentMethodId) {
  return httpClient.get(`/merchant/payment-methods/${paymentMethodId}`);
}

/**
 *
 * @param paymentMethodId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deletePaymentMethod(paymentMethodId) {
  return httpClient.delete(`/merchant/payment-methods/${paymentMethodId}`);
}

/**
 *
 * @param paymentMethodId
 * @param paymentMethod
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updatePaymentMethod(paymentMethodId, paymentMethod) {
  return httpClient.put(`/merchant/payment-methods/${paymentMethodId}`, paymentMethod);
}

/**
 *
 * @param paymentMethod
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newPaymentMethod(paymentMethod) {
  return httpClient.post('/merchant/payment-methods', paymentMethod);
}

// Merchant Specific APIs ends
// =========================================
